export async function retryOnFailure(action, errorHandler = null, timeout = 100, maxRetries = 100) {
  if (maxRetries == 0) return;

  try {
    await action();
  } catch (e) {
    errorHandler && errorHandler(e, maxRetries);
    await new Promise(resolve => setTimeout(resolve, timeout))
    return retryOnFailure(action, timeout, maxRetries - 1)
  }
}
